import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { JobService } from '../services/jobs/job.service';
import { StaffService } from '../services/staff/staff.service';
import { CourseService } from '../services/course.service';
import { LoginService } from '../services/login.service';
import { NotificationService } from '../services/notification.service';
@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  currentUser: any;
  courseCount
  jobCount
  trainerCount
  module = JSON.parse(localStorage.getItem('module'))
  constructor(
    public _jobService: JobService,
    public _loginService: LoginService,
    public _staffService: StaffService,
    public _courseService: CourseService,
    public notificationService: NotificationService,
    private router: Router,
  ) {
    this._loginService.currentUser.subscribe(x => this.currentUser = x);
    this.message = this.notificationService.currentMessage
  }

  jobs;
  instructors;
  courses;
  labourjobCount
  message
  jobsCount = 0

  ngOnInit() {
    this.getCount();
    this.currentUser = JSON.parse(localStorage.currentUser);
    console.log("cuureeent usre value in dashboard", this.currentUser);


  }


  redirectionOfListPage(route) {
    console.log("REdirect route name", route);
    this.router.navigate([route])
  }


  // API CALL

  getCount() {
    let that = this;
    this._loginService.getDashboardCount().subscribe((data) => {
      console.log("THIS IS THE NEW COUNT DATA", data, this.module);

      if (this.module && this.module.isStaff) this.trainerCount = data.staffCount
      if (this.module && this.module.isTrainingJob && this.module.isMpJob) this.jobCount = data.trainingJobCount + data.medicalJobCount, this.courseCount = data.courseCount
      if (this.module && this.module.isTrainingJob && !this.module.isMpJob) this.jobCount = data.trainingJobCount, this.courseCount = data.courseCount
      if (this.module && this.module.isLabourjob) this.labourjobCount = data.labourjobCount
      this.jobsCount = this.jobCount + this.labourjobCount
    })
  }

  getMail() {
    this._jobService.getMailList().subscribe((response) => {
      console.log("response of all mail que data", response);

    })
  }

}
